import { useState, useEffect, useMemo } from "react";
import { Home, FileText, FolderGit2, Settings, Menu, User } from "lucide-react";
import { Link } from "react-router-dom";

export default function Sidebar() {
    const [collapsed, setCollapsed] = useState(true);
    const [active, setActive] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    const setCollapsed_func = () => {
        setCollapsed(!collapsed);
        document.getElementById("feat").style.marginLeft = collapsed ? "300px" : "80px";
    }

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const items = useMemo(() => [
        { icon: Home, label: "Home", to: "#feat" },
        { icon: User, label: "About Me", to: "#about-me" },
        { icon: FileText, label: "Lebenslauf", to: "#cv" },
        { icon: FolderGit2, label: "Projekte", to: "#projects" },
        ...(isMobile ? [{ icon: Settings, label: "Einstellungen", to: "/settings" }] : [])
    ], [isMobile]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPos = window.scrollY + 150;

            let current = 0;

            items.forEach((item, index) => {

                // nur Anchor Links (#...) prüfen
                if (!item.to.startsWith("#")) return;

                const section = document.querySelector(item.to);
                if (!section) return;

                if (scrollPos >= section.offsetTop) {
                    current = index;
                }
            });

            setActive(current);
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, [items]);

    useEffect(() => {
    if (items[active]) {
        document.title = `${items[active].label} | James Schreiber Portfolio`;
    }
}, [active, items]);

    return (
        <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>

            <div className="menu">
                {items.map((item, i) => {
                    const Icon = item.icon;

                    if (item.to.startsWith("#")) {
                        return (
                            <a
                                key={i}
                                href={item.to}
                                className={`menu-item ${active === i ? "active" : ""}`}
                                onClick={() => setActive(i)}
                            >
                                <Icon size={22} />
                                {!collapsed && <span>{item.label}</span>}
                            </a>
                        );
                    }

                    return (
                        <Link
                            key={i}
                            to={item.to}
                            className="menu-item"
                        >
                            <Icon size={22} />
                            {!collapsed && <span>{item.label}</span>}
                        </Link>
                    );
                })}
            </div>

            <div className="button-bottom">

                {!isMobile && (
                    <Link to="/settings" className="settings toggle">
                        <Settings size={22} />
                        {!collapsed && <span>Einstellungen</span>}
                    </Link>
                )}

                <div className="settings toggle" onClick={setCollapsed_func}>
                    <Menu size={22} />
                    {!collapsed && <span>Menu</span>}
                </div>
            </div>

        </aside>
    );
}
